<template>
  <div class="discover-categories">
    <series-view />
  </div>
</template>

<script>
import SeriesViews from "@/views/Series.vue";

export default {
  name: "DiscoverCategories",
  components: {
    SeriesView: SeriesViews,
  },
};
</script>